export const CLAVE_DE_SESION = "sesion";

export const CABECERA_DE_SESION = "X-Sesion";

export const CABECERA_DE_RENOVACION = "x-sesion-renovada";

export const CABECERA_DE_ESTADO = "x-sesion-estado";

export const RUTA_DE_APERTURA = "sesion/abrir";

const CANAL_DE_SESION = "sesion-portal";

let canal: BroadcastChannel | null = null;

let cerrandoSesion = false;

let redirigiendo = false;

let aperturaEnCurso: Promise<void> | null = null;

interface ClienteDeSesion {
    postAsync: <T>(sourceName: string, params?: any) => Promise<T>;
}

const obtenerCanal = (): BroadcastChannel | null => {
    if (canal === null && typeof BroadcastChannel !== "undefined") {
        canal = new BroadcastChannel(CANAL_DE_SESION);
    }

    return canal;
};

export const obtenerSesion = (): string | null => sessionStorage.getItem(CLAVE_DE_SESION);

export const guardarSesion = (identificador: string) => sessionStorage.setItem(CLAVE_DE_SESION, identificador);

export const retirarSesion = () => sessionStorage.removeItem(CLAVE_DE_SESION);

export const registrarApertura = (apertura: Promise<void>): Promise<void> => {
    const enCurso: Promise<void> = apertura.then(
        () => {
            if (aperturaEnCurso === enCurso) {
                aperturaEnCurso = null;
            }
        },
        () => {
            if (aperturaEnCurso === enCurso) {
                aperturaEnCurso = null;
            }
        });

    aperturaEnCurso = enCurso;

    return enCurso;
};

export const esApertura = (ruta?: string): boolean =>
    !!ruta && ruta.replace(/^\/+/, "").toLowerCase().startsWith(RUTA_DE_APERTURA);

export const esperarApertura = async (): Promise<void> => {
    if (aperturaEnCurso === null && obtenerSesion() === null) {
        await new Promise<void>(resolve => setTimeout(resolve, 0));
    }

    if (aperturaEnCurso !== null) {
        await aperturaEnCurso;
    }
};

export const aplicarRenovacion = (nuevo?: string | null) => {
    const anterior = obtenerSesion();

    if (!nuevo || !anterior || nuevo === anterior) {
        return;
    }

    guardarSesion(nuevo);

    const canalDeSesion = obtenerCanal();

    if (canalDeSesion) {
        canalDeSesion.postMessage({ anterior, nuevo });
    }
};

export const escucharRenovaciones = () => {
    const canalDeSesion = obtenerCanal();

    if (!canalDeSesion) {
        return () => undefined;
    }

    const alRecibir = (evento: MessageEvent) => {
        const datos = evento.data || {};

        if (datos.anterior && datos.nuevo && obtenerSesion() === datos.anterior) {
            guardarSesion(datos.nuevo);
        }
    };

    canalDeSesion.addEventListener("message", alRecibir);

    return () => canalDeSesion.removeEventListener("message", alRecibir);
};

export const esSesionInvalida = (respuesta: any): boolean =>
    !!respuesta && respuesta.status === 401 && !!respuesta.headers && respuesta.headers[CABECERA_DE_ESTADO] === "invalida";

export const terminarSesionInvalida = () => {
    if (cerrandoSesion || redirigiendo) {
        return;
    }

    redirigiendo = true;
    retirarSesion();
    sessionStorage.removeItem("token");
    window.location.assign("/sesion-cerrada");
};

export const cerrarSesionEnServidor = async (api: ClienteDeSesion) => {
    if (!obtenerSesion()) {
        return;
    }

    cerrandoSesion = true;
    await api.postAsync("sesion/cerrar").catch(() => null);
    retirarSesion();
    cerrandoSesion = false;
};

export const retirarTokenDeLaDireccion = () => {
    const url = new URL(window.location.href);

    if (!url.searchParams.has("token")) {
        return;
    }

    url.searchParams.delete("token");
    window.history.replaceState(window.history.state, document.title, url.toString());
};

export const etiquetar = (valor: string | null): string | null => {
    if (!valor) {
        return null;
    }

    let hash = 0x811c9dc5;

    for (let i = 0; i < valor.length; i++) {
        hash ^= valor.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }

    return hash.toString(16).padStart(8, "0");
};
